
    <!--
 * 竖版-权益列表
 * @LastEditTime: Sat Feb 08 2025 17:56:13 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_GWKK49"  :class="[`normal`,`u_c_GWKK49`]" ><div id="u_c_L5EF21"  :style="`background: linear-gradient(to bottom,${ pageData.moduleColorUp },${ pageData.moduleColorDown });`" v-if="pageData.isEdit || pageData.collectRights.length" :class="[`normal`,`u_c_L5EF21`]" ><div id="u_c_CVO840"  :class="[`normal step-title`,`u_c_CVO840`]" ><div id="u_c_U1T841"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_U1T841`]" ></div><div id="u_c_TKZD42"  :style="`color:${ pageData.btnColor }`" :class="[`normal`,`u_c_TKZD42`]" >{{`${ langData.lineWelfare }`}}</div><div id="u_c_1ED144"  :style="`background-color:${ pageData.btnColor };opacity:0.2;`" :class="[`normal`,`u_c_1ED144`]" ></div></div><div id="u_c_CVSK45"  :style="`grid-template-columns:repeat(${ pageData.collectRights.length > 4 ? 4 : pageData.collectRights.length }, 1fr)`" :class="[`normal`,`u_c_CVSK45`]" ><div id="u_c_OGT746"  v-for="(forItem, forIndex) in compData.welfareList" :key="forIndex" v-show="pageData.isEdit || pageData.collectRights.includes(forItem.key)" :class="[`normal welfareItem`,`u_c_OGT746`]" ><div id="u_c_G9G547"  :class="[`normal`,`u_c_G9G547`]" ><div id="u_c_DI2648"  :style="`background: linear-gradient(to bottom,${ pageData.welfareBgColorUp },${ pageData.welfareBgColorDown });`" :class="[`normal`,`u_c_DI2648`]" ></div><div id="u_c_AFR349"  :style="`background-image:url(${ forItem.icon })`" :class="[`normal`,`u_c_AFR349`]" ></div></div><div id="u_c_D2BG62"  :class="[`normal content`,`u_c_D2BG62`]" >{{forItem.label}}</div></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import { Swiper, SwiperSlide } from "swiper/vue";import { Pagination } from "swiper";import "swiper/css";  import 'swiper/css/pagination';

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"welfareList":[{"label":"生日礼物","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723548942800-1.png","key":"1"},{"label":"会员活动","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723548942804-25.png","key":"1"},{"label":"实用工具","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723730876238-70.png","key":"1"},{"label":"快速提问","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723730876235-87.png","key":"1"},{"label":"专属客服","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723730876232-21.png","key":"1"},{"label":"节日关怀","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723730876240-27.png","key":"1"},{"label":"误操作处理","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723730876237-96.png","key":"1"},{"label":"更多福利","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723548942804-25.png","key":"1"}]},"zh-TW":{"welfareList":[{"label":"每週禮包","icon":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723548942804-25.png","key":"welfare_1724998997102_ju8n6z"},{"label":"會員活動","icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172499906405141124.png","key":"welfare_1724998997102_A8YrP5"},{"label":"實用工具","icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172499906438626208.png","key":"welfare_1724998997102_qOXwIK"},{"label":"更多福利","icon":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172499906498899263.png","key":"welfare_1724998997102_o1tgsI"}]}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "gm99"
    const router = Router();
    const route = useRoute();
    const compName = '权益列表';

    // 自定义setup - 开始
    ;const modules = computed(()=> [Pagination])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_GWKK49.normal{
position:relative;
box-sizing:border-box;
width:100%;
height:fit-content;
margin-bottom:0.27rem;
margin-top:7.75rem;

}
}.default{
.u_c_L5EF21.normal{
position:relative;
width:9.20rem;
height:fit-content;
background:#ffecc9;
margin-bottom:0.27rem;
border-radius:0.21rem;
padding:0.53rem 0.27rem;
box-sizing:border-box;
margin:0 auto;

}
}.default{
.u_c_CVO840.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;

}
}.default{
.u_c_U1T841.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_TKZD42.normal{
font-size:0.43rem;
color:#ffffff;
font-weight:bold;
line-height:0.43rem;
padding:0 0.13rem;

}
}.default{
.u_c_1ED144.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.default{
.u_c_CVSK45.normal{
position:relative;
width:100%;
display:grid;
margin-top:0.67rem;
grid-template-columns:repeat(4, 1fr);
 column-gap:0.75rem;
row-gap:0.40rem;
justify-items:center;

}
}.default{
.u_c_OGT746.normal{
position:relative;
width:1.60rem;
height:fit-content;
display:flex;
flex-direction:column;
text-align:center;

}
}.default{
.u_c_G9G547.normal{
position:relative;
width:1.60rem;
height:1.60rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_DI2648.normal{
position:absolute;
width:1.60rem;
height:1.60rem;
border-radius:1.60rem;
background:#000;

}
}.default{
.u_c_AFR349.normal{
position:relative;
width:0.67rem;
height:0.67rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.default{
.u_c_D2BG62.normal{
width:100%;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
word-break:break-word;
margin-top:0.33rem;

}
}.zh-TW{
.u_c_GWKK49.normal{
position:relative;
box-sizing:border-box;
width:100%;
height:fit-content;
margin-bottom:0.27rem;
margin-top:7.75rem;

}
}.zh-TW{
.u_c_L5EF21.normal{
position:relative;
width:9.20rem;
height:fit-content;
background:#ffecc9;
margin-bottom:0.27rem;
border-radius:0.21rem;
padding:0.53rem 0.27rem;
box-sizing:border-box;
margin:0 auto;

}
}.zh-TW{
.u_c_CVO840.normal{
position:relative;
width:100%;
display:flex;
justify-content:center;
align-items:center;
box-sizing:border-box;

}
}.zh-TW{
.u_c_U1T841.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.zh-TW{
.u_c_TKZD42.normal{
font-size:0.43rem;
color:#ffffff;
font-weight:bold;
line-height:0.43rem;
padding:0 0.13rem;

}
}.zh-TW{
.u_c_1ED144.normal{
position:relative;
height:0.01rem;
background:#000;
width:1.92rem;

}
}.zh-TW{
.u_c_CVSK45.normal{
position:relative;
width:100%;
display:grid;
margin-top:0.67rem;
grid-template-columns:repeat(4, 1fr);
 column-gap:0.75rem;
row-gap:0.40rem;
justify-items:center;

}
}.zh-TW{
.u_c_OGT746.normal{
position:relative;
width:1.60rem;
height:fit-content;
display:flex;
flex-direction:column;
text-align:center;

}
}.zh-TW{
.u_c_G9G547.normal{
position:relative;
width:1.60rem;
height:1.60rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_DI2648.normal{
position:absolute;
width:1.60rem;
height:1.60rem;
border-radius:1.60rem;
background:#000;

}
}.zh-TW{
.u_c_AFR349.normal{
position:relative;
width:0.67rem;
height:0.67rem;
background-repeat:no-repeat;
background-size:contain;
background-position:center;

}
}.zh-TW{
.u_c_D2BG62.normal{
width:100%;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
word-break:break-word;
margin-top:0.33rem;

}
}
</style>
